import * as _ from 'underscore';

import { RefreshContentScope } from '../../app/ActionPlaceScopes';
import { SelectedItemsScope } from '../controllers/ContentSubplaceCtrl';
import { IActionContext } from '../helpers/ActionContext';
import { CommonErrorCode } from '../helpers/ErrorCodes';
import { Set } from '../models/Set';
import { Module } from '../Module';
import { IResult } from '../ServerApi/types/IResponse';
import { SiteRoles } from '../ServerApi/types/ISiteRole';
import { ISiteUser } from '../ServerApi/types/ISiteUser';
import { ActionHelpers } from './ActionHelpers';
import { IActionButton } from './ActionPanelService';
import { ServerService } from './ServerService';
import { SetSiteUsersSiteRoleAction } from './SetSiteUsersSiteRoleAction';

export class SiteUsersActions {

  public static $inject = [
    'ServerService',
    'SetSiteUsersSiteRoleAction',
  ];

  constructor(
    private serverService: ServerService,
    private SetSiteUsersSiteRoleAction: SetSiteUsersSiteRoleAction,
  ) {}

  // action button factory

  // $note-ltan-1-28-2015
  // Used by SiteUsersPlace and GroupUsersSubplace
  public setSiteUsersSiteRoleAction(): IActionButton<ISiteUser, {}> {
    return {
      name: 'siteRole',
      translate: 'siteRole_action',
      isAvailable: (items: Set<ISiteUser>): boolean => this.canChangeRole(items),
      execute: (items: Set<any>, context: IActionContext) => {
        const scope = <RefreshContentScope & SelectedItemsScope<any>>context.scope;
        this.SetSiteUsersSiteRoleAction.showSetSiteUsersSiteRoleDialog(items, context)
          .then((result: IResult) => {
            ActionHelpers.deselectNotFound(scope.selectedItems, result, CommonErrorCode.SiteUserNotFound);
            scope.refreshContent();
          });
      }
    };
  }

  // Determine if change role action is allowed.
  // - Disallow if all selected users are server admins unless the current user is a Server Admin
  // - Disallow if the only selection is a guest user.
  // - Disallow site admins from attempting to change role of a set of all server admins
  // - Disallow if session user cannot manage users
  private canChangeRole(users: Set<ISiteUser>) {
    return ((users.size() > 0)
      && !SiteUsersActions.isSingleSelectAndGuest(users)
      && (!SiteUsersActions.areAllSelectedUsersServerAdmins(users) || this.serverService.isSessionServerAdmin()))
      && this.serverService.canSessionUserManageUsers();
  }

  private static isSingleSelectAndGuest(users: Set<ISiteUser>) {
    return (users.size() === 1 && users.first().siteRole === SiteRoles.Guest);
  }

  private static areAllSelectedUsersServerAdmins(users: Set<ISiteUser>): boolean {
    return _.every(users.toArray(), (user: ISiteUser) => {
      // return true if every user is server admin
      return (user.siteRole === SiteRoles.ServerAdministrator);
    });
  }

}

Module.instance().service('SiteUsersActions', SiteUsersActions);
